export const translations = {
  fr: {
    "topbar.brand": "Documentation",
    "nav.home": "Accueil",
    "nav.catalog": "Catalogue",
    "nav.search": "Recherche",
    "search.placeholder": "Rechercher…",
    "nav.addDoc": "Ajouter une doc",
    "nav.openMenu": "Ouvrir le menu",
    "nav.theme": "Thème",
    "nav.themeLight": "Clair",
    "nav.themeDark": "Sombre",
    "auth.loginTitle": "Explorateur de documentation",
    "auth.loginSubtitle": "Connectez-vous avec votre compte CodeFirst",
    "auth.loginButton": "Se connecter",
    "home.title": "Accueil",
    "home.favoritesTitle": "Favoris",
    "home.signInToSeeFavorites": "Connectez-vous pour voir vos favoris.",
    "home.noFavoritesYet":
      "Aucun favori pour le moment. Ouvrez une documentation puis cliquez sur Favori.",
    "home.openCatalog": "Ouvrir le catalogue",
    "catalog.title": "Catalogue",
    "new.title": "Ajouter une documentation",
    "new.name": "Nom",
    "new.gitUrl": "URL Git",
    "new.gitUrlHelper":
      "Saisir l’URL du dépôt en HTTPS hébergée sur la plateforme CodeFirst (ex. https://codefirst.…/…/… .git).",
    "new.visibility": "Visibilité",
    "new.type": "Type",
    "new.type.MARKDOWN": "Markdown",
    "new.type.STARLIGHT": "Starlight (Astro)",
    "new.type.DOCUSAURUS": "Docusaurus",
    "new.type.EXTERNAL_LINK": "Lien externe",
    "new.shortDescription": "Description brève (optionnel)",
    "new.shortDescriptionHelper": "Maximum 250 caractères.",
    "new.externalUrl": "URL cible (https ou http)",
    "new.externalUrlHelper":
      "L’ouverture se fera dans un nouvel onglet. Le contenu n’est pas hébergé sur CodeFirst.",
    "new.externalLinkTypeWarning":
      "Attention : l’accès n’est pas sécurisé par la plateforme CodeFirst (site externe).",
    "new.defaultBranch": "Branche par défaut (optionnel)",
    "new.imageProcessing": "Traitement…",
    "new.imageLabel": "Image de couverture (optionnel, JPEG 128x128 en base)",
    "new.remove": "Retirer",
    "new.saving": "Enregistrement",
    "new.create": "Créer",
    "edit.title": "Modifier la documentation",
    "edit.gitUrlLocked": "L’URL du dépôt Git n’est pas modifiable.",
    "edit.visibleLabel": "Visible",
    "edit.visibleHelper": "Masquée : seuls vous et les administrateurs pouvez la voir.",
    "edit.recloneNotice":
      "Changer le type ou la branche relance une synchronisation complète du dépôt.",
    "edit.save": "Enregistrer",
    "edit.notAllowed": "Vous n’avez pas les droits pour modifier cette documentation.",
    "doc.hiddenChip": "Masquée",
    "doc.hide": "Masquer (visible uniquement par vous et les admins)",
    "doc.show": "Rendre visible",
    "viewer.editDoc": "Modifier",
    "viewer.loading": "Chargement",
    "viewer.notFound": "Introuvable",
    "viewer.pageNotFound":
      "Cette page n’existe pas (ou plus) dans cette documentation. Le lien qui vous a amené ici est peut-être obsolète.",
    "viewer.pageNotFoundAction": "Première page",
    "viewer.cloneInProgress": "Clone en cours. Cliquez sur Rafraichir.",
    "viewer.refresh": "Rafraichir",
    "viewer.language": "Langue",
    "viewer.onThisPage": "Sur cette page",
    "viewer.favorite": "Favori",
    "viewer.unfavorite": "Retirer des favoris",
    "viewer.deleteDoc": "Supprimer",
    "viewer.resyncDoc": "Relancer la synchro",
    "viewer.resyncing": "Synchronisation…",
    "viewer.externalLinkWarning":
      "Attention : l’accès n’est pas sécurisé par la plateforme CodeFirst (contenu hébergé ailleurs).",
    "viewer.openExternalLink": "Ouvrir le lien",
    "viewer.deleteDocConfirm":
      "Supprimer cette documentation ? Cette action est irréversible (fichiers, index, favoris).",
    "viewer.searchOpen": "Rechercher dans la doc",
    "viewer.searchInputPlaceholder": "Rechercher une page…",
    "viewer.searchDialogTitle": "Rechercher dans cette documentation",
    "viewer.searchQueryPlaceholder": "Mots, titres, contenu des pages…",
    "viewer.searchBuilding": "Préparation de l’index de recherche",
    "viewer.searchNoResults": "Aucune page ne correspond à cette requête.",
    "viewer.searchError": "Impossible d’indexer le contenu.",
    "viewer.searchHint": "Flèches pour choisir · Entrée pour ouvrir · Échap pour fermer",
    "viewer.searchPageCount": "{n} page(s) dans l’index",
    "viewer.searchPartialIndex":
      "{n} page(s) n’ont pas pu être téléchargées : elles ne sont trouvables que par leur titre.",
    "viewer.sansIaTitle": "IA non merci",
    "viewer.sansIaBody":
      "Mes documents de cours (vidéos, tutoriels…) ont été réalisés sans IA. Merci de ne pas les verser dans une machine d’apprentissage par IA, sous peine de poursuite.",
    "level.YEAR_1": "BUT1",
    "level.YEAR_2": "BUT2",
    "level.YEAR_3": "BUT3",
    "level.TEACHERS": "Enseignants",
    "level.ADMIN": "Administrateurs",
    "level.OTHER": "Autre",
  },
  en: {
    "topbar.brand": "Documentation",
    "nav.home": "Home",
    "nav.catalog": "Catalog",
    "nav.search": "Search",
    "search.placeholder": "Search…",
    "nav.addDoc": "Add doc",
    "nav.openMenu": "Open menu",
    "nav.theme": "Theme",
    "nav.themeLight": "Light",
    "nav.themeDark": "Dark",
    "auth.loginTitle": "Documentation explorer",
    "auth.loginSubtitle": "Sign in with your CodeFirst account",
    "auth.loginButton": "Log in",
    "home.title": "Home",
    "home.favoritesTitle": "Favorites",
    "home.signInToSeeFavorites": "Sign in to see your favorites.",
    "home.noFavoritesYet": "No favorites yet. Open a documentation and click Favorite.",
    "home.openCatalog": "Open catalog",
    "catalog.title": "Catalog",
    "new.title": "Add documentation",
    "new.name": "Name",
    "new.gitUrl": "Git URL",
    "new.gitUrlHelper":
      "Use the CodeFirst Git repository URL over HTTPS (e.g. https://codefirst.…/…/….git).",
    "new.visibility": "Visibility",
    "new.type": "Type",
    "new.type.MARKDOWN": "Markdown",
    "new.type.STARLIGHT": "Starlight (Astro)",
    "new.type.DOCUSAURUS": "Docusaurus",
    "new.type.EXTERNAL_LINK": "External link",
    "new.shortDescription": "Short description (optional)",
    "new.shortDescriptionHelper": "Maximum 250 characters.",
    "new.externalUrl": "Target URL (https or http)",
    "new.externalUrlHelper": "Opens in a new tab. Content is not hosted on the CodeFirst platform.",
    "new.externalLinkTypeWarning":
      "Warning: access is not controlled by the CodeFirst platform (external site).",
    "new.defaultBranch": "Default branch (optional)",
    "new.imageProcessing": "Processing…",
    "new.imageLabel": "Cover image (optional, 128x128 JPEG in DB)",
    "new.remove": "Remove",
    "new.saving": "Saving",
    "new.create": "Create",
    "edit.title": "Edit documentation",
    "edit.gitUrlLocked": "The Git repository URL cannot be changed.",
    "edit.visibleLabel": "Visible",
    "edit.visibleHelper": "Hidden: only you and administrators can see it.",
    "edit.recloneNotice": "Changing the type or branch triggers a full repository resync.",
    "edit.save": "Save",
    "edit.notAllowed": "You are not allowed to edit this documentation.",
    "doc.hiddenChip": "Hidden",
    "doc.hide": "Hide (only you and admins can see it)",
    "doc.show": "Make visible",
    "viewer.editDoc": "Edit",
    "viewer.loading": "Loading",
    "viewer.notFound": "Not found",
    "viewer.pageNotFound":
      "This page does not exist (anymore) in this documentation. The link that brought you here may be outdated.",
    "viewer.pageNotFoundAction": "First page",
    "viewer.cloneInProgress": "Clone in progress. Click Refresh.",
    "viewer.refresh": "Refresh",
    "viewer.language": "Language",
    "viewer.onThisPage": "On this page",
    "viewer.favorite": "Favorite",
    "viewer.unfavorite": "Unfavorite",
    "viewer.deleteDoc": "Delete",
    "viewer.resyncDoc": "Resync",
    "viewer.resyncing": "Syncing…",
    "viewer.externalLinkWarning":
      "Warning: access is not secured by the CodeFirst platform (content hosted elsewhere).",
    "viewer.openExternalLink": "Open link",
    "viewer.deleteDocConfirm":
      "Delete this documentation? This cannot be undone (files, index, favorites).",
    "viewer.searchOpen": "Search in doc",
    "viewer.searchInputPlaceholder": "Search for a page…",
    "viewer.searchDialogTitle": "Search in this documentation",
    "viewer.searchQueryPlaceholder": "Words, titles, page content…",
    "viewer.searchBuilding": "Building the search index",
    "viewer.searchNoResults": "No pages match this query.",
    "viewer.searchError": "Could not index the content.",
    "viewer.searchHint": "Arrows to choose · Enter to open · Esc to close",
    "viewer.searchPageCount": "{n} page(s) in the index",
    "viewer.searchPartialIndex":
      "{n} page(s) could not be downloaded: they can only be found by title.",
    "viewer.sansIaTitle": "No AI, thank you",
    "viewer.sansIaBody":
      "My course materials (videos, tutorials, etc.) were produced without AI. Do not use them to train an AI system, or face possible legal action.",
    "level.YEAR_1": "BUT1",
    "level.YEAR_2": "BUT2",
    "level.YEAR_3": "BUT3",
    "level.TEACHERS": "Teachers",
    "level.ADMIN": "Admin",
    "level.OTHER": "Other",
  },
} as const;

export type AppLanguage = keyof typeof translations;
export type TranslationKey = keyof (typeof translations)["fr"];
